module.exports = __webpack_public_path__ + "media/images/Burger Menu-b30077ee19eafc10b9afe7953938f310.svg";